import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/Results/ResultsHeader.js";
const variants = import.meta.webpackContext("/components/Results", { recursive: true, regExp: /\.\/__variants__\/plp\-(?:filtering\-experience\/v2|mweb\-image\-gallery\/v3)\/ResultsHeader\.js/ });
export default pointCut({ joinPoint, variants });